const styles = (theme) => ({
    reponsiveTable: {
        overflowX: 'scroll',
        overflowY: 'hidden',
    },
    title: {
        fontWeight: '500',
        marginBottom: '0',
    },
    containerMainData: {
        marginTop: '30px',
    },
    loading: {
        marginTop: '25px',
    },
    centerProgress: {
        textAlign: 'center',
    },
    containerTable: {
        overflow: 'hidden',
    },
    table: {
        margin: '0 0 30px 0',
        backgroundColor: '#fff',
    },
    tableError: {
        borderCollapse: 'initial',
        margin: '0 0 30px 0',
        border: '2px solid #b71c1c',
        backgroundColor: '#fff',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    addButton: {
        borderRadius: '30px',
        padding: '5px 20px',
        border: 'none',
        color: theme.palette.primary.main,
        backgroundColor: '#fff',
        alignItems: 'center',
        display: 'flex',
        fontWeight: 'bold',
        fontFamily: theme.typography.fontFamily,
        float: 'right',
        marginTop: '0px',
    },
    btnSigleAction: {
        minWidth: '30px',
        height: '30px',
        lineHeight: '30px',
        borderRadius: '50%',
        display: 'inline-flex',
        color: '#fff',
        marginRight: '5px',
        padding: '0',
        fontSize: '16px',
    },
    titleTable: {
        fontWeight: '500',
    },
    verticalMiddle: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1rem',
    },
    radioGroup: {
        width: '100%',
        display: 'flex',
    },
    overflowScroll: {
        // overflow: 'scroll',
    },
    positionRelative: {
        position: 'relative',
    },
    circularProgress: {
        position: 'absolute',
        top: '23px',
        right: '40px',
    },
});

export default styles;
